<template>
	<div>
		<v-row align="center" class="grey lighten-5">
	      <v-col class="text-center" cols="12" sm="2">
	        <div class="my-2">
	          <router-link :to="'/base64-encode'">
	            <v-btn small :outlined="base64Encode"  color="primary" rounded dark>Base64 Encode</v-btn>
	          </router-link>
	        </div>
	      </v-col>
	      <v-col class="text-center" cols="12" sm="2">
	        <div class="my-2">
	          <router-link :to="'/base64-decode'">
	            <v-btn small :outlined="base64Decode" color="primary" rounded dark>Base64 Decode</v-btn>
	          </router-link>
	        </div>
	      </v-col>
	      <v-col class="text-center" cols="12" sm="2">
	        <div class="my-2">
	          <router-link :to="'/url-encode'">
	            <v-btn small :outlined="urlEncode" color="primary" rounded dark>URL Encode</v-btn>
	          </router-link>
	        </div>
	      </v-col>
	      <v-col class="text-center" cols="12" sm="2">
	        <div class="my-2">
	          <router-link :to="'/url-decode'">
	            <v-btn small :outlined="urlDecode" color="primary" rounded dark>URL Decode</v-btn>
	          </router-link>
	        </div>
	      </v-col>
	      <v-col class="text-center" cols="12" sm="2">
	        <div class="my-2">
	          <router-link :to="'/jwt-decode'">
	            <v-btn small :outlined="jwtDecode" color="primary" rounded dark>JWT Decode</v-btn>
	          </router-link>
	        </div>
	      </v-col>
	    </v-row>
	</div>
</template>
<script>
export default {
	props: {
		base64Encode: Boolean,
		base64Decode: Boolean,
		urlEncode: Boolean,
		urlDecode: Boolean,
		jwtDecode: Boolean,
	}
}
</script>

